import { render, staticRenderFns } from "./TopPostList.vue?vue&type=template&id=4c4b7553&scoped=true"
import script from "./TopPostList.vue?vue&type=script&lang=js"
export * from "./TopPostList.vue?vue&type=script&lang=js"
import style0 from "./TopPostList.vue?vue&type=style&index=0&id=4c4b7553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b7553",
  null
  
)

export default component.exports